import { motion } from 'framer-motion';

import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { routes } from '../../../constants/routes';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { useNavbarContext } from '../../../contexts/NavbarProvider';
import CollapsibleSideNavButton from '../Buttons/CollapsibleSideNavButton';
import SideNavButton from '../Buttons/SideNavButton';

const SideNavbar = () => {
  // integration of context hooks here
  const { showNavbar } = useNavbarContext();
  const { currentUserPermissions, currentUserType } = useAuthContext();

  // integration of react hooks here
  const sideNavbarRef = useRef<HTMLDivElement>(null);

  // setting scroll position to the navbar from session storage here
  useEffect(() => {
    if (sideNavbarRef.current) {
      const sideNavScrollPosition = JSON.parse(
        sessionStorage.getItem('s_s_pos') as string
      );

      sideNavbarRef.current.scroll({
        top: +sideNavScrollPosition,
        behavior: 'auto',
      });
    }
  }, []);

  // handler function for saving scroll position in session storage declared here
  const saveScrollPositionHandler = () => {
    if (sideNavbarRef.current) {
      const { scrollTop } = sideNavbarRef.current;

      sessionStorage.setItem('s_s_pos', scrollTop.toString());
    }
  };

  // rendering side navbar component here
  return (
    <motion.aside
      ref={sideNavbarRef}
      onScroll={saveScrollPositionHandler}
      initial={showNavbar ? { width: '260px' } : { width: '70px' }}
      animate={showNavbar ? { width: '260px' } : { width: '70px' }}
      className='hidden lg:block fixed top-0 h-screen bg-legal-dark-blue shadow-academia-sm z-[9999] overflow-auto no-scrollbar'
    >
      <motion.div
        initial={showNavbar ? { x: 0 } : { x: -260 }}
        animate={showNavbar ? { x: 0 } : { x: -260 }}
        className='sticky top-0 flex items-center justify-center min-h-[90px] bg-legal-dark-blue z-[999]'
      >
        <Link
          to={'/dashboard'}
          className='text-xl block w-[150px] hover:opacity-60 active:scale-95 duration-300 text-base-white italic'
        >
          <h1>Global Academia</h1>
        </Link>
      </motion.div>

      <nav className='italic mt-10 mb-5'>
        {currentUserPermissions.length || currentUserType === 'client'
          ? routes.map((route, index) =>
              route.subRoutes ? (
                <CollapsibleSideNavButton key={index} route={route} />
              ) : (
                <SideNavButton key={index} route={route} />
              )
            )
          : null}
      </nav>
    </motion.aside>
  );
};

export default SideNavbar;
